import { useQuery } from '@tanstack/react-query'
import { getCensusZendeskTicketJobs } from '../../api/census-enrollment-platform-api-client'
import {
  CensusZendeskTicketJobDto,
  CensusZendeskTicketJobStatus,
} from '../../api/dto/census-zendesk-ticket-job.dto'

export const CENSUS_TICKET_JOBS_QUERY_KEY = 'censusZendeskTicketJobs'

const ACTIVE_POLL_INTERVAL_MS = 3000

const ACTIVE_STATUSES = new Set<CensusZendeskTicketJobStatus>([
  'pending',
  'processing',
])

export function isActiveTicketJob(job: CensusZendeskTicketJobDto): boolean {
  return ACTIVE_STATUSES.has(job.status)
}

/**
 * Polls the background Zendesk ticket-creation jobs for a census file. Polling
 * runs every few seconds only while at least one job is still pending/processing
 * and stops automatically once everything reaches a terminal state.
 */
export function useCensusTicketJobsPolling(publicKey: string | undefined) {
  return useQuery({
    queryKey: [CENSUS_TICKET_JOBS_QUERY_KEY, publicKey],
    queryFn: () => getCensusZendeskTicketJobs(publicKey as string),
    enabled: !!publicKey,
    refetchInterval: (query) => {
      const jobs = query.state.data ?? []
      return jobs.some(isActiveTicketJob) ? ACTIVE_POLL_INTERVAL_MS : false
    },
    refetchIntervalInBackground: false,
  })
}
